import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input, DatePicker,} from 'antd';
import { useBnsYiXiangKeHuUpdateQuery, useBnsYiXiangKeHuUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import GetUserDept from '../../cpn/GetUserDept';
import dayjs from 'dayjs';
import MediaForm from '../../promote/media/MediaForm';
import { EditOutlined } from '@ant-design/icons';
import GetWebGoods from '../goods/GetWebGoods';
function ClientEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        byxkh_content:''
    }); 
    const {data,isSuccess} = useBnsYiXiangKeHuUpdateQuery({byxkh_id:props.byxkh_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    byxkh_name:data.Result.byxkh_name,
                    byxkh_dept_id:data.Result.byxkh_dept_id,
                    byxkh_content:data.Result.byxkh_content,
                    byxkh_meijie_id:data.Result.byxkh_meijie_id,
                    byxkh_bg_id:data.Result.byxkh_bg_id,
                    byxkh_bg_name:data.Result.byxkh_bg_name,
                    byxkh_riqi:dayjs(data.Result.byxkh_riqi),
                })
                setInfo(prevState=>({...prevState,
                    byxkh_name:data.Result.byxkh_name,
                    byxkh_dept_id:data.Result.byxkh_dept_id,
                    byxkh_dept_name:data.Result.byxkh_dept_name,
                    byxkh_content:data.Result.byxkh_content,
                    byxkh_meijie_id:data.Result.byxkh_meijie_id,
                    byxkh_meijie_name:data.Result.byxkh_meijie_name,
                    byxkh_bg_id:data.Result.byxkh_bg_id,  
                    byxkh_bg_name:data.Result.byxkh_bg_name,  
                    byxkh_riqi:data.Result.byxkh_riqi,                
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsYiXiangKeHuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined/>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改客户'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "byxkh_bg_id" : info.byxkh_bg_id,
                        "byxkh_bg_name" : info.byxkh_bg_name,
                        "byxkh_uid" : localStorage.getItem('eu_id'),
                        "byxkh_uname" : localStorage.getItem('eu_name'),
                        "byxkh_content" : info.byxkh_content,
                        "byxkh_dept_id" : info.byxkh_dept_id,
                        "byxkh_dept_name" : info.byxkh_dept_name,
                        "byxkh_e_id" : localStorage.getItem('e_id'),
                        "byxkh_meijie_id" : info.byxkh_meijie_id,
                        "byxkh_meijie_name" : info.byxkh_meijie_name,
                        "byxkh_name" : info.byxkh_name,
                        "byxkh_riqi" : info.byxkh_riqi,                                
                        "byxkh_id" : props.byxkh_id,                                
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <GetUserDept 
                        label='部门'
                        required
                        wrapperCol={{span:10}} 
                        getUserDept={(e,f) => {
                            setInfo(prevState=>({...prevState,byxkh_dept_id:e,byxkh_dept_name:f}))
                        }}
                        name='byxkh_dept_id'
                    />
                    <Form.Item name="byxkh_name" label='客户名称' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,byxkh_name:e.target.value}))}}
                        />
                    </Form.Item>                       
                    <MediaForm
                        required
                        wrapperCol={{span:10}}
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,byxkh_meijie_id:e,byxkh_meijie_name:f.label}))
                        }}
                        name='byxkh_meijie_id'
                    />
                    <Form.Item
                        label='获取日期'
                        name='byxkh_riqi'
                        wrapperCol={{span:10}}
                        required                            
                    >
                        <DatePicker 
                            onChange={(e) => {setInfo(prevState=>({...prevState,byxkh_riqi:dayjs(e).format('YYYY-MM-DD')}))}} 
                        />
                    </Form.Item>                      
                    <GetWebGoods
                        label='商品'
                        wrapperCol={{span:10}}
                        onChange={(e,f) => {
                            console.log(e,f);
                            setInfo(prevState=>({...prevState,byxkh_bg_id:e,byxkh_bg_name:f}))
                        }}
                        name='byxkh_bg_name'
                    />
                    <Form.Item
                        label='备注'
                        wrapperCol={{span:20}}
                        name='byxkh_content'
                    >
                        <Input
                            onChange={(e) => {setInfo(prevState=>({...prevState,byxkh_content:e.target.value}))}}
                            defaultValue={info.byxkh_content}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ClientEdit